import axios from 'axios'
import store from '../store'
import { openLoading, closeLoading} from '@/utils/index'
import {
  getToken
} from '../utils/auth'
import {
  Message,MessageBox
} from 'element-ui'

const service = axios.create({
  baseURL: '/cccmb_api',
  // timeout: 5000
})
service.interceptors.request.use(
  config => {
    openLoading(sessionStorage.getItem('loading'))
    //console.log("config.url=="+config.url)
    if(config.url.indexOf('?')>-1){
      config.url=config.url+`&n=${encodeURIComponent(Math.random())}`
    }
    else{
      config.url=config.url+`?n=${encodeURIComponent(Math.random())}`
    }

    if (store.getters.token) {
      config.headers['token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  response => {
    closeLoading()
    const res = response.data

    if (res.code !== 0) {
      Message.closeAll()
      Message({
        message: res.msg || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code == 900100) {
        Message.closeAll()
        MessageBox('您长时间未操作或令牌失效，请重新登录。', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then(() => {
          store.dispatch('user/resetToken')
        })

      }
      return Promise.reject(new Error(res.msg || 'Error'))
    } else {
      return res
    }
  },
  error => {
    closeLoading()
    Message.closeAll()

    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = error.response.data.msg
          break;
        case 500:
          error.message = '服务器内部错误，请联系客服人员！'
          break;
        default:  
          error.message = '系统异常，请联系客服人员！'
      }
    }

    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
